/** 清除额外的小数点 */
export const removeExtraDecimalPoints = (inputString?: number | string) => {
  // 使用正则表达式将多余的小数点移除
  const outputString = String(inputString)
    ?.replace(/。/g, '.')
    ?.replace(/\./g, (match, offset, original) => {
      return offset === original?.indexOf('.') ? match : '';
    });
  return outputString;
};

/** 清除中英文 */
export const getNumber = (input?: string) => {
  const value = input?.replace(/[^0-9.]/g, (match, index) => {
    if (match === '-' && index === 0) {
      return match;
    }
    return '';
  });

  if (!value) {
    return undefined;
  }

  return Number(value);
};
